export enum CostStatuses {
  active = 'active',
  outdated = 'outdated',
}

export enum CostsTabValue {
  active = '1',
  inactive = '0',
}
